import type { JSX } from 'react'
import type { ILayoutBlockProps } from '../LayoutBlock'

import { LayoutBlock } from '../LayoutBlock'
import { LayoutBlockDirection } from '../LayoutBlock.h'

export interface ILayoutBlockDirectionColumnProps extends ILayoutBlockProps {}

export const LayoutBlockDirectionColumn = ({
  children,
  width = '100%',
  height = 'calc(100% - 112px)',
  direction = LayoutBlockDirection.Column,
  ...rest
}: ILayoutBlockDirectionColumnProps): JSX.Element => (
  <LayoutBlock width={width} height={height} direction={direction} {...rest}>
    {children}
  </LayoutBlock>
)
